export default __webpack_public_path__ + "static/media/logo.d9acce6f.png";